//add-seed-page.tsx

import Button from "@mui/material/Button";
import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Box } from "@mui/material";
import { seedsApi } from "../services/api/seeds";
import { DateTime } from "luxon";
import mixpanel from "mixpanel-browser";
import { goBackOrTo } from "../utils/history";
import { ErrorContext } from "../components/app-routes";
import Page from "../components/page";
import SeedForm, { SeedFormValues } from "../components/seed-form";
import LoadingBackdrop from "../components/loading-backdrop";
import { FormikHelpers } from "formik";
import StickyActionBar from "../components/sticky-action-bar";
import { getCustomLabel } from "../utils/custom-labels";
import { UserContext } from "../components/app-routes";

export default function AddSeedPage() {
  const history = useHistory();
  const [busy, setBusy] = useState(false);
  const [saved, setSaved] = useState(false);
  const { handleError } = useContext(ErrorContext);

  const onSubmit = async (
    values: SeedFormValues,
    _helpers: FormikHelpers<SeedFormValues>,
  ) => {
    setBusy(true);

    try {
      await seedsApi.add({
        id: 0,
        name: values.name,
        variety: values.variety,
        notes: values.notes,
        archivedAt: values.archived ? DateTime.now().toISO() : null,
        lots: [],
      });

      mixpanel.track("Add Seed");

      setSaved(true);
    } catch (error) {
      handleError(error);
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    if (saved) {
      history.replace("/home/seeds");
    }
  }, [saved, history]);

  const context = useContext(UserContext);
  const grower = context.grower;

  return (
    <Page title={`Add ${getCustomLabel(grower ?? null, "seeds")}`}>
      {" "}
      <SeedForm
        initialValues={{
          name: "",
          id: 0,
          archived: false,
          notes: "",
          variety: "",
        }}
        onSubmit={onSubmit}
        saved={saved}
      >
        <StickyActionBar position="bottom">
          <Button
            variant="outlined"
            disabled={busy}
            onClick={() => goBackOrTo(history, "/home/seeds")}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            disabled={busy}
          >
            Add
          </Button>
        </StickyActionBar>
      </SeedForm>
      <LoadingBackdrop open={busy} />
    </Page>
  );
}
